module.exports = __webpack_public_path__ + "static/media/time-x-en.076e26c0.png";